
import Vue from "vue";
export default Vue.extend({
	data(){
		return {
			value: 0
		};
	},
	methods: {
		cancel(){
			console.log("cancel clicked");
			this.$emit("failure", new Error("canceled"));
		},
		confirm(){
			this.$emit("success", this.value);
		}
	},
	i18nEx: {
		componentPrefix: "components.settings-default"
	}
});
